import React, { memo, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import BrandLogo from "../common/BrandLogo/BrandLogo";
import SideBarTab from "./SideBarTab";
import classes from "./Sidebar.module.css";
import Logo from "../../assets/images/svg/Logo.svg";
import brandLogo from "../../assets/images/png/Logo@2x.png";
import ChangePasswordModal from "./ChangePasswordModal";
import LogoutConfirmation from "./LogoutConfirmation";
import SubscriptionPopup from "../Popups/SubscriptionPopup";

// Material Icons
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import PriceCheckOutlinedIcon from "@mui/icons-material/PriceCheckOutlined";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import MemorySharpIcon from "@mui/icons-material/MemorySharp";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
//routes and API's

import { Drawer } from "@mui/material";
import {
  ChatBubbleOutline,
  ChevronLeft,
  Close,
  CreditScoreOutlined,
  FormatQuoteRounded,
  JoinInnerOutlined,
  ManageSearchRounded,
  Menu,
  SupervisorAccount,
} from "@mui/icons-material";
import { setSideBarToggle } from "../../features/SideBarToggleSlice";

const Sidebar = ({
  buyerBtn,
  vendorBtn,
  buyerBtnOutline,
  vendorBtnOutlined,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const [subscriptionPopupOpen, setSubscriptionPopupOpen] = useState(false);

  const handleLogout = () => {
    setLogoutOpen(true);
  };

  // Handle menu click with demo user check
  const handleMenuClick = (menuItem, originalClickFunc) => {
    // Check if this is an advanced onboarding feature and user is demo
    const isAdvancedOnboarding =
      menuItem.title === "Advanced Onboarding" ||
      menuItem.title === "Vendor Compliance Verification";

    if (isAdvancedOnboarding && isDemoUser) {
      setSubscriptionPopupOpen(true);
      return;
    }

    // For sub-options, check the sub-option titles
    if (menuItem.subOptions) {
      const hasAdvancedSubOption = menuItem.subOptions.some(
        (sub) =>
          sub.title === "Advanced Onboarding" ||
          sub.title === "Vendor Compliance Verification"
      );

      if (hasAdvancedSubOption && isDemoUser) {
        // We'll handle this in the sub-option click handler
        return originalClickFunc();
      }
    }

    return originalClickFunc();
  };

  //get data from use selector
  const data = useSelector((state) => state.loginData.value);
  const sideBarToggled = useSelector((state) => state.sideBarToggle.value);

  // Check if current user is demo user
  const isDemoUser =
    data?.user?.email === "rameshwar.galwa@acer.com" ||
    data?.user?.email === "maya.kamath@altoscomputing.com";

  const handleToggleSidebar = () => {
    dispatch(setSideBarToggle(!sideBarToggled));
  };

  //roles
  const [roles, setRoles] = useState({
    SuperAdmin: "",
    Admin: "",
    Buyer: "",
    VendorAdmin: "",
    VendorContact: "",
    User: "",
  });

  function checkPathAdmin(pathname) {
    return location.pathname == `/admin/${pathname}`;
  }
  function checkPath(pathname) {
    return location.pathname == `/Organization_dashboard/${pathname}`;
  }
  function checkPathBuyer(pathname) {
    return location.pathname == `/Buyer_dashboard/${pathname}`;
  }
  function checkPathUser(pathname) {
    return location.pathname == `/User_dashboard/${pathname}`;
  }
  function checkPathVendor(pathname) {
    return location.pathname == `/Vendors_dashboard/${pathname}`;
  }

  let locationName = location.pathname.split("/");
  const [finalPath, setFinalPath] = useState();
  let adminPathInitial = "/admin";

  const [superadminDashboard, setSuperAdminDashboard] = useState([
    {
      title: "Home",
      icon: <HomeOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <HomeOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("/welcome"),
      path: "/welcome",
    },
    {
      title: "Customer Command Centre",
      icon: <Person2OutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <Person2OutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathAdmin("buyer_access") || finalPath === "buyer_access",

      path: `${adminPathInitial}/buyer_access`, // ✅ correct path
    },
    {
      title: "Invite Buyer Admin",
      icon: <SupervisorAccount sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <SupervisorAccount
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive:
        checkPathAdmin("invitebuyeradmin") || finalPath === "invitebuyeradmin",
      path: `${adminPathInitial}/invitebuyeradmin`, // ✅ correct path
    },
    {
      title: "AI Dialogue",
      icon: <FormatQuoteRounded sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <FormatQuoteRounded
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathAdmin("Prompt") || finalPath === "Prompt",
      path: `${adminPathInitial}/Prompt`, // ✅ correct path
    },
    {
      title: "RFQ Category",
      icon: <ManageSearchRounded sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <ManageSearchRounded
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive:
        checkPathAdmin("Prompt_creation") || finalPath === "Prompt_creation",
      path: `${adminPathInitial}/Prompt_creation`, // ✅ correct path
    },
    {
      title: "User Logs",
      icon: <SettingsAccessibilityIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <SettingsAccessibilityIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathAdmin("UserLogs") || finalPath === "UserLogs",
      path: `${adminPathInitial}/UserLogs`, // ✅ correct path
    },
  ]);

  let orgPathInitial = "/Organization_dashboard";

  const [orgDashboard, setOrgDashboard] = useState([
    {
      id: 0,
      title: "Home",
      icon: <HomeOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <HomeOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("/welcome"),
      path: "/welcome",
    },
    {
      id: 18,
      title: "RFQ Automation",
      icon: <RequestQuoteOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <RequestQuoteOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPath("RFQ") || finalPath === "RFQ",
      path: "/Organization_dashboard/RFQ",
    },
    {
      id: 19,
      title: "PO Automation",
      icon: <DescriptionOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <DescriptionOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("PO"),
      path: "/Organization_dashboard/PO",
    },
    {
      id: 20,
      title: "Users",
      icon: <PeopleAltOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <PeopleAltOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPath("Buyers") || finalPath === "Buyers",
      path: "/Organization_dashboard/Buyers",
    },
    {
      id: 21,
      title: "Master Records",
      icon: <InventoryOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <InventoryOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPath("Items") || finalPath === "Items",
      path: "/Organization_dashboard/Items",
      subOptions: [
        {
          id: 24,
          title: "Item Master",
          path: "/Organization_dashboard/Items",
          icon: <InventoryOutlinedIcon fontSize="small" />,
        },
        {
          id: 25,
          title: "Vendor Master",
          path: "/Organization_dashboard/Vendors",
          icon: <StoreOutlinedIcon fontSize="small" />,
        },
        {
          id: 26,
          title: "Tax Master",
          path: "/Organization_dashboard/GstTab",
          icon: <ReceiptOutlinedIcon fontSize="small" />,
        },
      ],
    },
    {
      id: 22,
      title: "Accounting Codes",
      icon: <AccountTreeOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <AccountTreeOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPath("CostCenterTab") || finalPath === "CostCenterTab",
      path: "/Organization_dashboard/CostCenterTab",
      subOptions: [
        {
          id: 27,
          title: "Cost Center",
          path: "/Organization_dashboard/CostCenterTab",
          icon: <AccountTreeOutlinedIcon fontSize="small" />,
        },
        {
          id: 28,
          title: "GL Code",
          path: "/Organization_dashboard/GLTab",
          icon: <CodeOutlinedIcon fontSize="small" />,
        },
        {
          id: 29,
          title: "Project Code",
          path: "/Organization_dashboard/ProjectsTab",
          icon: <AssignmentOutlinedIcon fontSize="small" />,
        },
      ],
    },
    {
      id: 23,
      title: "Approver Range",
      icon: <LocalAtmOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <LocalAtmOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPath("Slab") || finalPath === "Slab",
      path: "/Organization_dashboard/Slab",
      subOptions: [
        {
          id: 30,
          title: "PO Approver Range",
          path: "/Organization_dashboard/Slab",
          icon: <LocalAtmOutlinedIcon fontSize="small" />,
        },
        {
          id: 31,
          title: "PR Approver Range",
          path: "/Organization_dashboard/PRSlab",
          icon: <AssessmentOutlinedIcon fontSize="small" />,
        },
        {
          id: 32,
          title: "TWM Approver Range",
          path: "/Organization_dashboard/twm_slab",
          icon: <AssessmentOutlinedIcon fontSize="small" />,
        },
      ],
    },
    {
      id: 1, // ✅ Dashboard
      title: "Dashboard",
      icon: <DashboardOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <DashboardOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPath("Dashboard"),
      path: "/Organization_dashboard/Dashboard",
    },
  ]);

  let buyerPathInitial = "/Buyer_dashboard";
  let userPathInitial = "/User_dashboard";
  let grnpath = "/GRN_Dashboard";
  let chatIntialPath = "/Chat_Dashboard";

  // const [buyerDashboard, setBuyerDashboard] = useState([
  //   {
  //     id: 0,
  //     title: "Home",
  //     icon: <HomeOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <HomeOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("/welcome"),
  //     path: "/welcome",
  //   },
  //   {
  //     id: 12, // ✅ Vendor & Merchant Onboarding
  //     title: "Vendor Onboarding Automation",
  //     icon: <MailOutlineOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <MailOutlineOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     path: `${buyerPathInitial}/Invite`,
  //     tabActive: checkPathBuyer("Invite"),
  //     subOptions: [
  //       {
  //         id: 14, // ✅ Reports & Analytics
  //         title: "Reports & Analytics",
  //         path: `${buyerPathInitial}/Invite`,
  //         icon: <AnalyticsOutlinedIcon fontSize="small" />,
  //       },
  //       {
  //         id: 15, // ✅ Advanced Onboarding
  //         title: "Advanced Onboarding",
  //         path: `${buyerPathInitial}/verification`,
  //         icon: <HowToRegOutlinedIcon fontSize="small" />,
  //       },
  //       {
  //         id: 0, // ⚠️ Custom: Vendor Compliance Verification (not in backend JSON)
  //         title: "Vendor Compliance Verification",
  //         path: `${buyerPathInitial}/PanToCinUploader`,
  //         icon: <HowToRegOutlinedIcon fontSize="small" />,
  //       },
  //     ],
  //   },
  //   {
  //     id: 2, // ✅ PR
  //     title: "Purchase Requisition",
  //     icon: <NoteAddOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <NoteAddOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("PR"),
  //     path: `${buyerPathInitial}/PR`,
  //   },
  //   {
  //     id: 3, // ✅ RFQ
  //     title: "RFQ Automation",
  //     icon: <RequestQuoteOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <RequestQuoteOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("RFQ"),
  //     path: `${buyerPathInitial}/RFQ`,
  //   },
  //   {
  //     id: 4, // ✅ Quick RFQ
  //     title: "Quick RFQ",
  //     icon: <RequestQuoteOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <RequestQuoteOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("QuickRFQ"),
  //     path: `${buyerPathInitial}/QuickRFQ`,
  //   },
  //   {
  //     id: 5, // ✅ PO Automation
  //     title: "PO Automation",
  //     icon: <DescriptionOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <DescriptionOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("PO"),
  //     path: `${buyerPathInitial}/PO`,
  //   },
  //   {
  //     id: 6, // ✅ Comparison
  //     title: "Comparison Automation",
  //     icon: <CompareArrowsOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <CompareArrowsOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("Comparison"),
  //     path: `${buyerPathInitial}/Comparison`,
  //   },
  //   {
  //     id: 10, // ✅ GRN
  //     title: "GRN Automation",
  //     icon: <ChecklistOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <ChecklistOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive:
  //       location.pathname === `${grnpath}/GRN` || finalPath === "GRN",
  //     path: `${grnpath}/GRN`,
  //   },
  //   {
  //     id: 16, // ✅ Invoice Automation
  //     title: "Merchant Invoice Automation",
  //     icon: <ReceiptOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <ReceiptOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     path: `${buyerPathInitial}/Invoice`,
  //   },
  //   {
  //     id: 7, // ✅ Master Records
  //     title: "Master Records",
  //     icon: <InventoryOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <InventoryOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("Items"),
  //     path: `${buyerPathInitial}/Items`,
  //     subOptions: [
  //       {
  //         id: 8, // ✅ Item Master
  //         title: "Item Master",
  //         path: `${buyerPathInitial}/Items`,
  //         icon: <InventoryOutlinedIcon fontSize="small" />,
  //       },
  //       {
  //         id: 9, // ✅ Vendor Master
  //         title: "Vendor Master",
  //         path: `${buyerPathInitial}/Vendors`,
  //         icon: <StoreOutlinedIcon fontSize="small" />,
  //       },
  //     ],
  //   },
  //   {
  //     id: 11, // ✅ MRP
  //     title: "MRP",
  //     icon: <AttachMoneyOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <AttachMoneyOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("MRP"),
  //     path: `${buyerPathInitial}/MRP`,
  //   },
  //   {
  //     id: 17, // ✅ Three Way Matching
  //     title: "Three Way Matching",
  //     icon: <JoinInnerOutlined sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <JoinInnerOutlined
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("Matching"),
  //     path: `${buyerPathInitial}/Matching`,
  //   },
  //   {
  //     id: 1, // ✅ Dashboard
  //     title: "Dashboard",
  //     icon: <DashboardOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
  //     activeIcon: (
  //       <DashboardOutlinedIcon
  //         color="primary"
  //         sx={{ fontSize: 24, strokeWidth: 1 }}
  //       />
  //     ),
  //     tabActive: checkPathBuyer("Dashboard"),
  //     path: `${buyerPathInitial}/Dashboard`,
  //   },
  // ]);

  const [buyerDashboard, setBuyerDashboard] = useState([
    {
      id: 0, // custom
      title: "Home",
      icon: <HomeOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <HomeOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("/welcome"),
      path: "/welcome",
    },
    {
      id: 12, // ✅ Vendor & Merchant Onboarding
      title: "Vendor Onboarding Automation",
      icon: <MailOutlineOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <MailOutlineOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      path: `${buyerPathInitial}/Invite`,
      tabActive: checkPathBuyer("Invite"),
      subOptions: [
        {
          id: 14, // ✅ Reports & Analytics
          title: "Reports & Analytics",
          path: `${buyerPathInitial}/Invite`,
          icon: <AnalyticsOutlinedIcon fontSize="small" />,
        },
        {
          id: 15, // ✅ Advanced Onboarding
          title: "Advanced Onboarding",
          path: `${buyerPathInitial}/verification`,
          icon: <HowToRegOutlinedIcon fontSize="small" />,
        },
        {
          id: 0, // ⚠️ Custom
          title: "Vendor Compliance Verification",
          path: `${buyerPathInitial}/PanToCinUploader`,
          icon: <HowToRegOutlinedIcon fontSize="small" />,
        },
      ],
    },
    {
      id: 2, // ✅ PR
      title: "Purchase Requisition",
      icon: <NoteAddOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <NoteAddOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("PR"),
      path: `${buyerPathInitial}/PR`,
    },
    {
      id: 3, // ✅ RFQ
      title: "RFQ Automation",
      icon: <RequestQuoteOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <RequestQuoteOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("RFQ"),
      path: `${buyerPathInitial}/RFQ`,
    },
    {
      id: 4, // ✅ Quick RFQ
      title: "Quick RFQ",
      icon: <RequestQuoteOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <RequestQuoteOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("QuickRFQ"),
      path: `${buyerPathInitial}/QuickRFQ`,
    },
    {
      id: 5, // ✅ PO
      title: "PO Automation",
      icon: <DescriptionOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <DescriptionOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("PO"),
      path: `${buyerPathInitial}/PO`,
    },
    {
      id: 6, // ✅ Comparison
      title: "Comparison Automation",
      icon: <CompareArrowsOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <CompareArrowsOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("Comparison"),
      path: `${buyerPathInitial}/Comparison`,
    },
    {
      id: 10, // ✅ GRN
      title: "GRN Automation",
      icon: <ChecklistOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <ChecklistOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: location.pathname === `${grnpath}/GRN` || finalPath === "GRN",
      path: `${grnpath}/GRN`,
    },
    {
      id: 16, // ✅ Invoice Automation
      title: "Merchant Invoice Automation",
      icon: <ReceiptOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <ReceiptOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      path: `${buyerPathInitial}/Invoice`,
    },
    {
      id: 7, // ✅ Master Records
      title: "Master Records",
      icon: <InventoryOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <InventoryOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("Items"),
      path: `${buyerPathInitial}/Items`,
      subOptions: [
        {
          id: 8, // ✅ Item Master
          title: "Item Master",
          path: `${buyerPathInitial}/Items`,
          icon: <InventoryOutlinedIcon fontSize="small" />,
        },
        {
          id: 9, // ✅ Vendor Master
          title: "Vendor Master",
          path: `${buyerPathInitial}/Vendors`,
          icon: <StoreOutlinedIcon fontSize="small" />,
        },
      ],
    },
    {
      id: 11, // ✅ MRP
      title: "MRP",
      icon: <AttachMoneyOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <AttachMoneyOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("MRP"),
      path: `${buyerPathInitial}/MRP`,
    },
    {
      id: 17, // ✅ Three Way Matching
      title: "Three Way Matching",
      icon: <JoinInnerOutlined sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <JoinInnerOutlined
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("Matching"),
      path: `${buyerPathInitial}/Matching`,
    },
    {
      id: 6,
      title: "Rate Contract",
      icon: (
        <AssignmentTurnedInOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />
      ),
      activeIcon: (
        <AssignmentTurnedInOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("rate_contract"),
      path: `${buyerPathInitial}/rate_contract`,
    },
    {
      id: 1, // ✅ Dashboard
      title: "Dashboard",
      icon: <DashboardOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <DashboardOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathBuyer("Dashboard"),
      path: `${buyerPathInitial}/Dashboard`,
    },
  ]);

  const reorderAndFlagMenu = (menus, allowedIds) => {
    return menus.map((menu) => ({
      ...menu,
      disabled: !allowedIds.includes(menu.id),
      // disabled: menu.title !== "Home" && !allowedIds.includes(menu.id),
      subOptions: menu.subOptions?.map((sub) => ({
        ...sub,
        disabled: !allowedIds.includes(sub.id),
      })),
    }));
  };

  useEffect(() => {
    if (!Array.isArray(data.allowed_menu)) return;

    // Parse allowed_menu if it’s coming as a string in user object
    let allowedIds = [];
    if (typeof data.allowed_menu === "string") {
      try {
        allowedIds = JSON.parse(data.allowed_menu);
      } catch {
        allowedIds = [];
      }
    } else {
      allowedIds = data.allowed_menu;
    }

    // For Buyer Dashboard
    let buyerMenuIds = [0, ...allowedIds, 17]; // keep Home & Matching always
    const updatedBuyerMenus = reorderAndFlagMenu(buyerDashboard, buyerMenuIds);
    setBuyerDashboard(updatedBuyerMenus);

    // For Organization Dashboard (Admin)
    let orgMenuIds = [0, ...allowedIds]; // keep Home always
    const updatedOrgMenus = reorderAndFlagMenu(orgDashboard, orgMenuIds);
    setOrgDashboard(updatedOrgMenus);
  }, [data.allowed_menu]);

  const [userDashboard, setUserDashboard] = useState(() => {
    const designation = data?.user?.designation;
    const department = data?.user?.department;

    const baseMenu = [
      {
        title: "Home",
        icon: <HomeOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <HomeOutlinedIcon
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        tabActive: checkPathUser("welcome"),
        path: "/welcome",
      },

      {
        title: "PR",
        icon: <NoteAddOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <NoteAddOutlinedIcon
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        tabActive: checkPathUser("PR"),
        path: `${userPathInitial}/PR`,
      },
      (designation === "Invoice Analyst" ||
        designation === "Finance Analyst") && {
        title: "Merchant Invoice Automation",
        icon: <ReceiptOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <ReceiptOutlinedIcon
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        path: `${userPathInitial}/Invoice`,
      },
      (designation === "Account Payable" ||
        designation === "Business Finance") && {
        title: "Invoice",
        icon: <PriceCheckOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <PriceCheckOutlinedIcon
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        path: `${userPathInitial}/ApproveInvoice`,
      },

      // (designation === "Account Payable" ||
      //   designation === "Finance Analyst") &&

      {
        title: "Invoice Automation",
        icon: <JoinInnerOutlined sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <JoinInnerOutlined
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        tabActive: checkPathBuyer(""),
        path: `${userPathInitial}/Matching`,
      },

      {
        title: "PO Automation",
        icon: <DescriptionOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <DescriptionOutlinedIcon
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        tabActive: checkPathUser("PO"),
        path: `${userPathInitial}/PO`,
      },
      (designation === "Procurement" || department === "Procurement") && {
        title: "Onboarding Approval",
        icon: <CreditScoreOutlined sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <CreditScoreOutlined
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        path: `${userPathInitial}/vendor_approval`,
      },
      {
        title: "Chat",
        icon: <ChatBubbleOutline sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <ChatBubbleOutline
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        path: `${chatIntialPath}/Chat`,
      },
      designation === "Store Manager" && {
        title: "GRN Automation",
        icon: <ChecklistOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <ChecklistOutlinedIcon
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        path: `${grnpath}/GRN`,
      },
      {
        title: "Dashboard",
        icon: <DashboardOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
        activeIcon: (
          <DashboardOutlinedIcon
            color="primary"
            sx={{ fontSize: 24, strokeWidth: 1 }}
          />
        ),
        tabActive: checkPathUser(""),
        path: `${userPathInitial}/Dashboard`,
      },
    ];

    return baseMenu.filter(Boolean);
  });

  let vendorPathInitial = "/Vendor_dashboard";
  const [vendorAdminDashboard, setVendorAdminDashboard] = useState([
    {
      title: "Home",
      icon: <HomeOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <HomeOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor("welcome"),
      path: "/welcome",
    },

    {
      title: "Bid Submission",
      icon: <RequestQuoteOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <RequestQuoteOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor("RFQ"),
      path: `${vendorPathInitial}/RFQ`,
    },
    {
      title: "Merchant Invoice",
      icon: <ReceiptOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <ReceiptOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor("Vendor Invoice"),
      path: `${vendorPathInitial}/Vendor Invoice`,
    },
    {
      title: "Invoice Process",
      icon: <MemorySharpIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <MemorySharpIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor("InvoiceProcess"),
      path: `${vendorPathInitial}/InvoiceProcess`,
    },
    {
      title: "Vendor User",
      icon: <PersonOutlineOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <PersonOutlineOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor("Users"),
      path: `${vendorPathInitial}/Users`,
    },
    {
      title: "Dashboard",
      icon: <DashboardOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <DashboardOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor("Dashboard"),
      path: `${vendorPathInitial}/Dashboard`,
    },
  ]);

  const [vendorContactDashboard, setVendorContactDashboard] = useState([
    {
      title: "Home",
      icon: <HomeOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <HomeOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor(""),
      path: "/welcome",
    },

    {
      title: "Bid Submission",
      icon: <RequestQuoteOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <RequestQuoteOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor("RFQ"),
      path: `${vendorPathInitial}/RFQ`,
    },

    {
      title: "Dashboard",
      icon: <DashboardOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      activeIcon: (
        <DashboardOutlinedIcon
          color="primary"
          sx={{ fontSize: 24, strokeWidth: 1 }}
        />
      ),
      tabActive: checkPathVendor(""),
      path: `${vendorPathInitial}/Dashboard`,
    },
  ]);

  const accountItems = [
    {
      title: "Settings",
      icon: (
        <SettingsSuggestOutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />
      ),
      onClick: () => setOpenChangePassword(true),
      tabActive: openChangePassword,
    },
    {
      title: "My Profile",
      icon: <Person2OutlinedIcon sx={{ fontSize: 24, strokeWidth: 1 }} />,
      path: roles.Buyer
        ? `/Buyer_dashboard/My_profile`
        : roles.VendorAdmin || roles.VendorContact
        ? `/Vendor_dashboard/My_profile`
        : `/Organization_dashboard/My_profile`,
      tabActive:
        location.pathname === `/Buyer_dashboard/My_profile` ||
        location.pathname === `/Vendor_dashboard/My_profile` ||
        location.pathname === `/Organization_dashboard/My_profile`,
    },
  ];

  useEffect(() => {
    setRoles({
      SuperAdmin:
        data?.access_type === "superadmin" ||
        data?.access_type === "superAdmin",
      Admin: data?.access_type === "admin" || data?.access_type === "Admin",
      Buyer: data?.access_type === "buyer" || data?.access_type === "Buyer",
      User: data?.access_type === "user" || data?.access_type === "User",
      VendorAdmin:
        data?.access_type === "vendor admin" ||
        data?.access_type === "Vendor admin",
      VendorContact:
        data?.access_type === "vendor contact" ||
        data?.access_type === "Vendor contact",
    });
    setFinalPath(locationName[locationName.length - 1]);
  }, [location.pathname]);

  const toggleActiveSuperAdmin = (index) => {
    const updatedDashboard = superadminDashboard.map((e, i) => ({
      ...e,
      tabActive: i === index,
    }));
    setSuperAdminDashboard(updatedDashboard);
  };

  const toggleActiveAdmin = (index) => {
    const updatedDashboard = orgDashboard.map((e, i) => ({
      ...e,
      tabActive: i === index,
    }));
    setOrgDashboard(updatedDashboard);
  };

  const togglesActiveBuyer = (index) => {
    const updatedDashboard = buyerDashboard.map((e, i) => ({
      ...e,
      tabActive: i === index,
    }));
    setBuyerDashboard(updatedDashboard);
  };

  const togglesActiveUser = (index) => {
    const updatedDashboard = userDashboard.map((e, i) => ({
      ...e,
      tabActive: i === index,
    }));
    setUserDashboard(updatedDashboard);
  };

  const togglesActiveVendor = (index) => {
    const updatedDashboard = vendorAdminDashboard.map((e, i) => ({
      ...e,
      tabActive: i === index,
    }));
    setVendorAdminDashboard(updatedDashboard);
  };

  const togglesActiveVendorContact = (index) => {
    const updatedDashboard = vendorContactDashboard.map((e, i) => ({
      ...e,
      tabActive: i === index,
    }));
    setVendorContactDashboard(updatedDashboard);
  };

  const localeStorageRemove = () => {
    localStorage.setItem("rfq_page_number", 1);
    localStorage.setItem("rfq_organ_page_number", 1);
    localStorage.setItem("rfq_vendor_page_number", 1);
  };

  const handleLogoutConfirm = () => {
    setLogoutOpen(false);
  };

  const sideBarFrame = (
    <div className={classes.menu_wrapper}>
      <div className={classes.optionwrapper}>
        {roles.SuperAdmin
          ? superadminDashboard.map((e, i) => (
              <SideBarTab
                key={i}
                roles={roles}
                icon={e.icon}
                activeIcon={e.activeIcon}
                clickFunc={() => {
                  handleCloseSideBar();
                  toggleActiveSuperAdmin(i);
                  localeStorageRemove();
                }}
                tabName={e.title}
                active={e.tabActive}
                navigatePath={e.path}
                subOptions={e?.subOptions}
                collapsed={sideBarToggled}
              />
            ))
          : roles.Admin
          ? orgDashboard.map((e, i) => (
              <SideBarTab
                key={i}
                roles={roles}
                icon={e.icon}
                activeIcon={e.activeIcon}
                disabled={e.disabled}
                clickFunc={() => {
                  if (e.disabled) return;
                  handleCloseSideBar();
                  toggleActiveAdmin(i);
                  localeStorageRemove();
                }}
                tabName={e.title}
                active={e.tabActive}
                navigatePath={e.path}
                subOptions={e?.subOptions}
                collapsed={sideBarToggled}
              />
            ))
          : roles.Buyer
          ? buyerDashboard.map((e, i) => (
              <SideBarTab
                key={i}
                roles={roles}
                icon={e.icon}
                activeIcon={e.activeIcon}
                disabled={e.disabled}
                clickFunc={() => {
                  // Check for advanced onboarding features for demo user
                  const isAdvancedOnboarding =
                    e.title === "Vendor Onboarding Automation";

                  if (isAdvancedOnboarding && isDemoUser) {
                    setSubscriptionPopupOpen(true);
                    return;
                  }

                  handleCloseSideBar();
                  togglesActiveBuyer(i);
                  localeStorageRemove();
                }}
                tabName={e.title}
                active={e.tabActive}
                navigatePath={e.path}
                subOptions={e?.subOptions?.map((subOption) => ({
                  ...subOption,
                  isDemoUser: isDemoUser,
                  onSubscriptionClick: () => setSubscriptionPopupOpen(true),
                }))}
                collapsed={sideBarToggled}
              />
            ))
          : roles.User
          ? userDashboard.map((e, i) => (
              <SideBarTab
                key={i}
                roles={roles}
                icon={e.icon}
                activeIcon={e.activeIcon}
                clickFunc={() => {
                  handleCloseSideBar();
                  togglesActiveUser(i);
                  localeStorageRemove();
                }}
                tabName={e.title}
                active={e.tabActive}
                navigatePath={e.path}
                subOptions={e?.subOptions}
                collapsed={sideBarToggled}
              />
            ))
          : roles.VendorAdmin
          ? vendorAdminDashboard.map((e, i) => (
              <SideBarTab
                key={i}
                roles={roles}
                icon={e.icon}
                activeIcon={e.activeIcon}
                clickFunc={() => {
                  handleCloseSideBar();
                  togglesActiveVendor(i);
                  localeStorageRemove();
                }}
                tabName={e.title}
                active={e.tabActive}
                navigatePath={e.path}
                subOptions={e?.subOptions}
                collapsed={sideBarToggled}
              />
            ))
          : roles.VendorContact &&
            vendorContactDashboard.map((e, i) => (
              <SideBarTab
                key={i}
                roles={roles}
                icon={e.icon}
                activeIcon={e.activeIcon}
                clickFunc={() => {
                  handleCloseSideBar();
                  togglesActiveVendorContact(i);
                  localeStorageRemove();
                }}
                tabName={e.title}
                active={e.tabActive}
                navigatePath={e.path}
                subOptions={e?.subOptions}
                collapsed={sideBarToggled}
              />
            ))}
      </div>
      <hr className={classes.sidebar_divider} />
      <div className={classes.menu_group}>
        {accountItems.map((item, index) => (
          <SideBarTab
            key={`account-${index}`}
            roles={roles}
            icon={item.icon}
            activeIcon={React.cloneElement(item.icon, { color: "primary" })}
            clickFunc={() => {
              handleCloseSideBar();
              if (item.onClick) {
                item.onClick(); // Handle onClick if exists
              } else if (item.path) {
                navigate(item.path);
                localeStorageRemove();
              }
            }}
            tabName={item.title}
            active={item.tabActive}
            navigatePath={item.path}
            collapsed={sideBarToggled}
          />
        ))}
      </div>
    </div>
  );

  // opensidebar
  const [openSideBar, setOpenSideBar] = useState(false);
  const handleOpenSideBar = () => setOpenSideBar(true);
  const handleCloseSideBar = () => setOpenSideBar(false);

  return (
    <>
      {/* Mobile Hamburger Menu */}
      <div className={classes.mobile_menu_toggle} onClick={handleOpenSideBar}>
        <MenuRoundedIcon fontSize="large" />
      </div>

      {/* Desktop Sidebar */}
      <div
        className={`${classes.sidebar_container} ${
          sideBarToggled ? classes.collapsed : ""
        }`}
      >
        {/* Top Brand Logo + Toggle Button */}
        <div className={classes.brand_logo_container}>
          <div
            className={`${classes.logo_row} ${
              sideBarToggled ? classes.logo_row_centered : ""
            }`}
          >
            <div style={{ width: "12.5rem" }}>
              {!sideBarToggled && (
                <BrandLogo imgSrc={brandLogo} imgAlt="BrandLogo" />
              )}
            </div>
            <div
              className={classes.sidebar_toggle_btn}
              onClick={handleToggleSidebar}
            >
              <MenuRoundedIcon
                className={classes.toggle_icon}
                sx={{ fontSize: 28 }}
              />
            </div>
          </div>
        </div>

        {/* User Profile Section */}
        <div className={classes.sidebar_content}>
          <div className={classes.sidebar_inner}>
            {/* Top Section (Menu) */}
            <div className={classes.menu_wrapper}>
              <div className={classes.optionwrapper}>{sideBarFrame}</div>
            </div>

            {/* Bottom Section (User Info) */}
            <div className={classes.user_wrapper}>
              <div className={classes.user_avatar}>
                <img
                  src={data?.user?.profile_image}
                  alt={data?.user?.first_name || "User"}
                  className={classes.avatar_img}
                />
              </div>

              <div className={classes.user_info}>
                <h4 className={classes.user_name}>
                  {data?.user?.first_name || "User"}
                </h4>
                <p className={classes.user_role}>
                  {data?.user?.role || data?.user?.designation || "Role"}
                </p>
              </div>

              {!sideBarToggled && (
                <div className={classes.logout_icon} onClick={handleLogout}>
                  <LogoutRoundedIcon fontSize="medium" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={openSideBar}
        onClose={handleCloseSideBar}
        classes={{ paper: classes.mobile_drawer }}
      >
        <div className={classes.mobile_drawer_header}>
          <div className={classes.mobile_logo_row}>
            <BrandLogo imgSrc={brandLogo} imgAlt="BrandLogo" />
            <div
              onClick={handleCloseSideBar}
              className={classes.sidebar_toggle_btn}
            >
              <MenuRoundedIcon
                className={classes.toggle_icon}
                sx={{ fontSize: 28 }}
              />
            </div>
          </div>
        </div>

        <div className={classes.mobile_drawer_content}>
          <div className={classes.mobile_sidebar_frame}>{sideBarFrame}</div>

          <div className={classes.user_wrapper}>
            <div className={classes.user_avatar}>
              <img
                src={data?.user?.profile_image}
                alt={data?.user?.first_name || "User"}
                className={classes.avatar_img}
              />
            </div>

            <div className={classes.user_info}>
              <h4 className={classes.user_name}>
                {data?.user?.first_name || "User"}
              </h4>
              <p className={classes.user_role}>{data?.user?.role || "Role"}</p>
            </div>

            <div className={classes.logout_icon} onClick={handleLogout}>
              <LogoutRoundedIcon fontSize="medium" />
            </div>
          </div>
        </div>
      </Drawer>

      <div>
        {/* Add ChangePasswordModal to the return */}
        <ChangePasswordModal
          open={openChangePassword}
          onClose={() => setOpenChangePassword(false)}
          buyerBtn={buyerBtn}
          vendorBtn={vendorBtn}
        />
        <LogoutConfirmation
          open={logoutOpen}
          onClose={() => setLogoutOpen(false)}
          buyerBtn={buyerBtn}
          vendorBtn={vendorBtn}
          buyerBtnOutline={buyerBtnOutline}
          vendorBtnOutlined={vendorBtnOutlined}
        />
        <SubscriptionPopup
          open={subscriptionPopupOpen}
          onClose={() => setSubscriptionPopupOpen(false)}
        />
      </div>
    </>
  );
};

export default memo(Sidebar);
